export default __webpack_public_path__ + "static/media/medway-watermark.03fb5747.svg";